import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Onboarding from "@/pages/Onboarding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Onboarding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
